module.exports = __webpack_public_path__ + "img/GreenOutline640.b8990fe0.png";